
import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getListaProvinceDocumentoIdentificativo(apiPath) {
  return (dispatch) => {
    API.getAxios(apiPath).get('/anagrafica/province')
      .then(response => { 
        dispatch({ type: actionTypes.LISTA_PROVINCE_DOCUMENTO_IDENTIFICATIVO, payload: response.data});
      })
      .catch(errore => { 
        //dispatch({ type: actionTypes.LISTA_PROVINCE_DOCUMENTO_IDENTIFICATIVO, payload: errore.response.data});
        message.error(`Errore: ${errore.response.data.errorMessage}`,15);

       })
  };
}

export default getListaProvinceDocumentoIdentificativo;